<template>
  <div :class="[{ edited_scrollbar: isMac }]" class="mx-4 mb-3">
    <div v-if="getRestrictStatus" class="mt-n16">
      <Error403 />
    </div>
    <div>
      <div :class="getDisbaleFlag == true ? 'disable-div' : ''">
        <v-data-table
          id="v-data-table-reports"
          :height="
            $vuetify.breakpoint.md
              ? 'calc(100vh - 150px)'
              : $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
              ? 'calc(100vh - 200px)'
              : 'calc(100vh - 115px)'
          "
          ref="leads-table"
          fixed-header
          :headers="
            getReportsView == 'project'
              ? projectHeaders.filter((item) => {
                  return getReportColumn(item.value);
                })
              : getReportsView == 'leader'
              ? leadHeaders.filter((item) => {
                  return getReportColumn(item.value);
                })
              : headers.filter((item) => {
                  return getReportColumn(item.value);
                })
          "
          :mobile-breakpoint="0"
          :loading="true"
          show-expand
          loading-text="No data available"
          :items-per-page="perPage"
          :page="currentPage"
          @pagination="updatePagination"
          :search="search"
          :items="
            getReportsView == 'project'
              ? filteredProjectEntries
              : getReportsView == 'leader'
              ? filteredMemberEntries
              : getReportsView == 'user'
              ? filteredMemberEntries
              : []
          "
          :expanded="
            getReportsView == 'leader' &&
            (getSearchedName || getSearchedDepartment || getSearchedDesignation)
              ? filteredMemberEntries
              : []
          "
          disable-sort
          :class="isMac ? 'edited_scrollbar' : ''"
          class="elevation-0 table-border mt-4"
          hide-default-footer
          :item-class="
            (item) => {
              return getReportsView == 'leader' || getReportsView == 'project'
                ? ''
                : '';
            }
          "
        >
          <template v-slot:[`header.name`]="{ header }">
            <div class="dark-purple-text">
              {{ header.text }}
            </div>
          </template>
          <template v-slot:[`header.role`]="{ header }">
            <div
              class="dark-purple-text pointer"
              @click="
                roleSort == 'asc'
                  ? $store.commit('setRoleSorting', (roleSort = 'desc'))
                  : roleSort == 'desc'
                  ? $store.commit('setRoleSorting', (roleSort = 'asc'))
                  : $store.commit('setRoleSorting', (roleSort = 'asc'))
              "
            >
              {{ header.text }}
              <v-icon v-if="getReportsView == 'user'" color="#2a206a" small>
                {{ roleSort == "asc" ? " mdi-arrow-up" : " mdi-arrow-down" }}
              </v-icon>
            </div>
          </template>
          <template v-slot:[`header.department`]="{ header }">
            <div class="dark-purple-text">
              {{ header.text }}
            </div>
          </template>
          <template v-slot:[`header.designation`]="{ header }">
            <div class="dark-purple-text">
              {{ header.text }}
            </div>
          </template>
          <template v-slot:[`header.to_others`]="{ header }">
            <div
              @click="
                toOthersSort == 'asc'
                  ? $store.commit('setToOthersSort', (toOthersSort = 'desc'))
                  : toOthersSort == 'desc'
                  ? $store.commit('setToOthersSort', (toOthersSort = 'asc'))
                  : $store.commit('setToOthersSort', (toOthersSort = 'asc'))
              "
              class="dark-purple-text pointer"
            >
              {{ header.text }}
              <v-icon color="#2a206a" small>
                {{
                  toOthersSort == "asc" ? " mdi-arrow-up" : " mdi-arrow-down"
                }}
              </v-icon>
            </div>
          </template>
          <template v-slot:[`header.by_others`]="{ header }">
            <div
              @click="
                byOthersSort == 'asc'
                  ? $store.commit('setByOthersSort', (byOthersSort = 'desc'))
                  : byOthersSort == 'desc'
                  ? $store.commit('setByOthersSort', (byOthersSort = 'asc'))
                  : $store.commit('setByOthersSort', (byOthersSort = 'asc'))
              "
              class="dark-purple-text pointer"
            >
              {{ header.text }}
              <v-icon color="#2a206a" small>
                {{
                  byOthersSort == "asc" ? " mdi-arrow-up" : " mdi-arrow-down"
                }}
              </v-icon>
            </div>
          </template>
          <template v-slot:[`header.completed`]="{ header }">
            <div
              class="dark-purple-text pointer"
              @click="
                completedSort == 'asc'
                  ? $store.commit(
                      'setCompletedTaskSorting',
                      (completedSort = 'desc')
                    )
                  : completedSort == 'desc'
                  ? $store.commit(
                      'setCompletedTaskSorting',
                      (completedSort = 'asc')
                    )
                  : $store.commit(
                      'setCompletedTaskSorting',
                      (completedSort = 'asc')
                    )
              "
            >
              {{ header.text }}
              <v-icon color="#2a206a" small>
                {{
                  completedSort == "asc" ? " mdi-arrow-up" : " mdi-arrow-down"
                }}
              </v-icon>
            </div>
          </template>
          <template v-slot:[`header.pending`]="{ header }">
            <div
              class="dark-purple-text pointer"
              @click="
                pendingSort == 'asc'
                  ? $store.commit(
                      'setPendingTaskSorting',
                      (pendingSort = 'desc')
                    )
                  : pendingSort == 'desc'
                  ? $store.commit(
                      'setPendingTaskSorting',
                      (pendingSort = 'asc')
                    )
                  : $store.commit(
                      'setPendingTaskSorting',
                      (pendingSort = 'asc')
                    )
              "
            >
              {{ header.text }}
              <v-icon color="#2a206a" small>
                {{ pendingSort == "asc" ? " mdi-arrow-up" : " mdi-arrow-down" }}
              </v-icon>
            </div>
          </template>
          <template v-slot:[`header.overdue`]="{ header }">
            <div
              class="dark-purple-text pointer"
              @click="
                overdueSort == 'asc'
                  ? $store.commit(
                      'setOverdueTaskSorting',
                      (overdueSort = 'desc')
                    )
                  : overdueSort == 'desc'
                  ? $store.commit(
                      'setOverdueTaskSorting',
                      (overdueSort = 'asc')
                    )
                  : $store.commit(
                      'setOverdueTaskSorting',
                      (overdueSort = 'asc')
                    )
              "
            >
              {{ header.text }}
              <v-icon color="#2a206a" small>
                {{ overdueSort == "asc" ? " mdi-arrow-up" : " mdi-arrow-down" }}
              </v-icon>
            </div>
          </template>
          <template v-slot:[`header.expired`]="{ header }">
            <v-tooltip
              content-class="arrow-up"
              color="#DCD8F3"
              bottom
              :nudge-left="40"
            >
              <template #activator="{ on }">
                <div
                  v-on="on"
                  id="expired-header-tooltip"
                  @click="
                    expiredSort == 'asc'
                      ? $store.commit(
                          'setExpiredTaskSorting',
                          (expiredSort = 'desc')
                        )
                      : expiredSort == 'desc'
                      ? $store.commit(
                          'setExpiredTaskSorting',
                          (expiredSort = 'asc')
                        )
                      : $store.commit(
                          'setExpiredTaskSorting',
                          (expiredSort = 'asc')
                        )
                  "
                  class="dark-purple-text pointer"
                >
                  {{ header.text }}
                  <v-icon color="#2a206a" small>
                    {{
                      expiredSort == "asc" ? " mdi-arrow-up" : " mdi-arrow-down"
                    }}
                  </v-icon>
                </div>
              </template>

              <span class="dark-purple-text font-weight-bold"
                >Expired task is a task which is completed after due date</span
              >
            </v-tooltip>
          </template>
          <template v-slot:[`header.time_spent`]="{ header }">
            <div
              class="dark-purple-text pointer"
              @click="
                timeSpentSort == 'asc'
                  ? $store.commit('setTimeSpentSort', (timeSpentSort = 'desc'))
                  : timeSpentSort == 'desc'
                  ? $store.commit('setTimeSpentSort', (timeSpentSort = 'asc'))
                  : $store.commit('setTimeSpentSort', (timeSpentSort = 'asc'))
              "
            >
              {{ header.text }}
              <v-icon color="#2a206a" small>
                {{
                  timeSpentSort == "asc" ? " mdi-arrow-up" : " mdi-arrow-down"
                }}
              </v-icon>
            </div>
          </template>
          <template v-slot:[`header.total_time`]="{ header }">
            <div
              class="dark-purple-text pointer"
              @click="
                timeSpentSort == 'asc'
                  ? $store.commit('setTimeSpentSort', (timeSpentSort = 'desc'))
                  : timeSpentSort == 'desc'
                  ? $store.commit('setTimeSpentSort', (timeSpentSort = 'asc'))
                  : $store.commit('setTimeSpentSort', (timeSpentSort = 'asc'))
              "
            >
              {{ header.text }}
              <v-icon color="#2a206a" small>
                {{
                  timeSpentSort == "asc" ? " mdi-arrow-up" : " mdi-arrow-down"
                }}
              </v-icon>
            </div>
          </template>

          <template v-slot:[`header.action`]="{ header }">
            <div class="d-flex dark-purple-text justify-end mr-6">
              {{ header.text }}
            </div>
          </template>
          <v-progress-linear
            v-show="fetchLinearLoader"
            slot="progress"
            color="#2a206a"
            indeterminate
          ></v-progress-linear>
          <template v-slot:[`body.prepend`]="{ headers }">
            <tr v-if="getReportsView != 'project'">
              <td v-for="(header, i) in headers" :key="i">
                <div v-if="header.value == 'name'" class="sub-header">
                  <div class="inputContainer">
                    <!-- <v-icon small class="mt-3"> mdi-magnify </v-icon>
                  <input
                    autocomplete="off"
                    v-model="searchedName"
                    type="text"
                    size="15"
                    id="name-search"
                    class="header-search-input-field mb-1 mt-2 rounded-2 inp-width"
                    placeholder="Search..."
                  /> -->
                    <v-menu
                      v-if="getSelectedCompany.role != 'employee'"
                      offset-y
                      content-class="bg-white"
                    >
                      <template #activator="{ on: onMenu }">
                        <v-btn
                          small
                          height="22"
                          outlined
                          class="text-capitalize theme-border dark-purple-text d-flex align-center caption ml-n4"
                          text
                          tile
                          v-on="{ ...onMenu }"
                        >
                          {{
                            getSearchedName
                              ? getSearchedName.name
                                ? getSearchedName.name
                                : getSearchedName.email
                              : "All"
                          }}
                        </v-btn>
                      </template>
                      <div :class="isMac ? 'edited_scrollbar' : ''">
                        <div class="search-border rounded ma-2">
                          <v-text-field
                            autocomplete="off"
                            class="body-2"
                            color="#757096"
                            prepend-inner-icon="mdi-magnify"
                            background-color="white"
                            placeholder="Search by name"
                            hide-details
                            dense
                            flat
                            solo
                            autofocus
                            v-model="searchName"
                          >
                          </v-text-field>
                        </div>
                        <v-list max-height="180" class="overflow-scroll">
                          <div
                            v-if="!searchName"
                            class="d-flex pa-1 pl-4 pr-2 pointer"
                            :class="!getSearchedName ? 'bg-selected' : ''"
                            @click="$store.commit('setSearchedName', null)"
                          >
                            <profileImage
                              v-show="':username'"
                              inline
                              username="All"
                              :size="18"
                              :userProfile="true"
                              :circular="true"
                            >
                            </profileImage>
                            <div class="caption mx-2">All Members</div>
                            <v-spacer></v-spacer>
                            <v-icon
                              small
                              color="#1cc283"
                              class="justify-end"
                              v-show="!getSearchedName"
                            >
                              mdi-check-box-outline</v-icon
                            >
                          </div>
                          <div
                            v-for="member in filteredMembers"
                            :key="member.id"
                            class="caption pa-1 pl-4 pr-2 pointer d-flex"
                            :class="
                              getSearchedName && getSearchedName.id == member.id
                                ? 'bg-selected'
                                : ''
                            "
                            @click="
                              getSearchedName && member.id == getSearchedName.id
                                ? $store.commit('setSearchedName', null)
                                : $store.commit('setSearchedName', member)
                            "
                          >
                            <profileImage
                              v-show="member.image ? ':src' : ':username'"
                              :src="member.image"
                              inline
                              :username="
                                member.name ? member.name : member.email
                              "
                              :size="18"
                              :userProfile="true"
                              :circular="true"
                            >
                            </profileImage>
                            <div
                              class="d-inline-block text-truncate mx-2"
                              style="max-width: 100px"
                              :class="member.name ? 'text-capitalize' : ''"
                            >
                              {{ member.name ? member.name : member.email }}
                            </div>
                            <v-spacer></v-spacer>
                            <v-icon
                              small
                              color="#1cc283"
                              class="justify-end"
                              v-show="
                                getSearchedName &&
                                  getSearchedName.id == member.id
                              "
                            >
                              mdi-check-box-outline</v-icon
                            >
                          </div>
                          <div v-if="searchName && !filteredMembers.length">
                            <p class="no-results-found my-1">
                              No results found
                            </p>
                          </div>
                        </v-list>
                      </div>
                    </v-menu>
                  </div>
                </div>
                <div
                  v-if="
                    header.value == 'role' &&
                      getSelectedCompany.role != 'employee'
                  "
                  class="sub-header"
                >
                  <div v-if="getReportsView == 'user'" class="inputContainer">
                    <v-menu offset-y>
                      <template #activator="{ on: onMenu }">
                        <v-btn
                          small
                          height="22"
                          outlined
                          class="text-capitalize theme-border dark-purple-text d-flex align-center caption ml-n4"
                          :class="
                            getSearchedRole == 'team-manager'
                              ? 'inp-width'
                              : 'btn-width'
                          "
                          text
                          tile
                          v-on="{ ...onMenu }"
                        >
                          {{ getSearchedRole ? getSearchedRole : "All" }}
                        </v-btn>
                      </template>
                      <v-list>
                        <div
                          v-for="list in roles"
                          :key="list.text"
                          class="caption pa-1 pl-4 pr-2 pointer d-flex"
                          :class="
                            getSearchedRole == list.value ? 'bg-selected' : ''
                          "
                          @click="
                            $store.commit('setSearchedRole', {
                              role: list.value,
                            })
                          "
                        >
                          <div>
                            {{ list.text }}
                          </div>
                          <v-spacer></v-spacer>
                          <v-icon
                            small
                            color="#1cc283"
                            class="justify-end"
                            v-show="getSearchedRole == list.value"
                          >
                            mdi-check-box-outline</v-icon
                          >
                        </div>
                      </v-list>
                    </v-menu>
                  </div>
                </div>
                <div v-if="header.value == 'department'" class="sub-header">
                  <div class="inputContainer">
                    <!-- <v-icon small class="mt-3"> mdi-magnify </v-icon>
                  <input
                    autocomplete="off"
                    v-model="searchedDepartment"
                    type="text"
                    size="15"
                    id="department-search"
                    class="header-search-input-field mb-1 mt-2 rounded-2 inp-width"
                    placeholder="Search..."
                  /> -->
                    <v-menu
                      v-if="getDepartments"
                      offset-y
                      content-class="bg-white"
                    >
                      <template #activator="{ on: onMenu }">
                        <v-btn
                          small
                          height="22"
                          outlined
                          class="text-capitalize theme-border dark-purple-text d-flex align-center caption ml-n4"
                          text
                          tile
                          v-on="{ ...onMenu }"
                        >
                          {{
                            getSearchedDepartment
                              ? getSearchedDepartment == "no_department"
                                ? "No Department"
                                : getSearchedDepartment
                              : "All"
                          }}
                        </v-btn>
                      </template>
                      <div :class="isMac ? 'edited_scrollbar' : ''">
                        <div class="search-border rounded ma-2">
                          <v-text-field
                            autocomplete="off"
                            class="body-2"
                            color="#757096"
                            prepend-inner-icon="mdi-magnify"
                            background-color="white"
                            placeholder="Search by department"
                            hide-details
                            dense
                            flat
                            solo
                            autofocus
                            v-model="searchDepartment"
                          >
                          </v-text-field>
                        </div>
                        <v-list max-height="180" class="overflow-scroll">
                          <div
                            v-if="!searchDepartment"
                            class="d-flex pa-1 pl-4 pr-2 pointer"
                            :class="!getSearchedDepartment ? 'bg-selected' : ''"
                            @click="
                              $store.commit('setSearchedDepartment', {
                                department: null,
                              })
                            "
                          >
                            <profileImage
                              v-show="':username'"
                              inline
                              username="All"
                              :size="18"
                              :userProfile="true"
                              :circular="true"
                            >
                            </profileImage>
                            <div class="caption mx-2">All Departments</div>
                            <v-spacer></v-spacer>
                            <v-icon
                              small
                              color="#1cc283"
                              class="justify-end"
                              v-show="!getSearchedDepartment"
                            >
                              mdi-check-box-outline</v-icon
                            >
                          </div>
                          <div
                            v-if="!searchDepartment"
                            class="d-flex pa-1 pl-4 pr-2 pointer"
                            :class="
                              getSearchedDepartment == 'no_department'
                                ? 'bg-selected'
                                : ''
                            "
                            @click="
                              $store.commit('setSearchedDepartment', {
                                department: 'no_department',
                              })
                            "
                          >
                            <profileImage
                              v-show="':username'"
                              inline
                              username="No Department"
                              :size="18"
                              :userProfile="true"
                              :circular="true"
                            >
                            </profileImage>
                            <div class="caption font-italic grey--text mx-2">
                              No Departments
                            </div>
                            <v-spacer></v-spacer>
                            <v-icon
                              small
                              color="#1cc283"
                              class="justify-end"
                              v-show="getSearchedDepartment == 'no_department'"
                            >
                              mdi-check-box-outline</v-icon
                            >
                          </div>
                          <div
                            v-for="department in filteredDepartments"
                            :key="department.id"
                            class="caption pa-1 pl-4 pr-2 pointer d-flex"
                            :class="
                              getSearchedDepartment &&
                              getSearchedDepartment == department.name
                                ? 'bg-selected'
                                : ''
                            "
                            @click="
                              getSearchedDepartment &&
                              getSearchedDepartment == department.name
                                ? $store.commit('setSearchedDepartment', {
                                    department: null,
                                  })
                                : $store.commit('setSearchedDepartment', {
                                    department: department.name,
                                  })
                            "
                          >
                            <profileImage
                              v-show="':username'"
                              inline
                              :username="department.name"
                              :size="18"
                              :userProfile="true"
                              :circular="true"
                            >
                            </profileImage>
                            <div
                              class="d-inline-block text-truncate mx-2 text-capitalize"
                              style="max-width: 100px"
                            >
                              {{ department.name }}
                            </div>
                            <v-spacer></v-spacer>
                            <v-icon
                              small
                              color="#1cc283"
                              class="justify-end"
                              v-show="
                                getSearchedDepartment &&
                                  getSearchedDepartment == department.name
                              "
                            >
                              mdi-check-box-outline</v-icon
                            >
                          </div>
                          <div
                            v-if="
                              searchDepartment && !filteredDepartments.length
                            "
                          >
                            <p class="no-results-found my-1">
                              No results found
                            </p>
                          </div>
                        </v-list>
                      </div>
                    </v-menu>
                  </div>
                </div>
                <div v-if="header.value == 'designation'" class="sub-header">
                  <div class="inputContainer">
                    <!-- <v-icon small class="mt-3"> mdi-magnify </v-icon>
                  <input
                    autocomplete="off"
                    v-model="searchedDepartment"
                    type="text"
                    size="15"
                    id="department-search"
                    class="header-search-input-field mb-1 mt-2 rounded-2 inp-width"
                    placeholder="Search..."
                  /> -->
                    <v-menu
                      v-if="getDesignations"
                      offset-y
                      content-class="bg-white"
                    >
                      <template #activator="{ on: onMenu }">
                        <v-btn
                          small
                          height="22"
                          outlined
                          class="text-capitalize theme-border dark-purple-text d-flex align-center caption ml-n4"
                          text
                          tile
                          v-on="{ ...onMenu }"
                        >
                          {{
                            getSearchedDesignation
                              ? getSearchedDesignation == "no_designation"
                                ? "No Designation"
                                : getSearchedDesignation
                              : "All"
                          }}
                        </v-btn>
                      </template>
                      <div :class="isMac ? 'edited_scrollbar' : ''">
                        <div class="search-border rounded ma-2">
                          <v-text-field
                            autocomplete="off"
                            class="body-2"
                            color="#757096"
                            prepend-inner-icon="mdi-magnify"
                            background-color="white"
                            placeholder="Search by department"
                            hide-details
                            dense
                            flat
                            solo
                            autofocus
                            v-model="searchDesignation"
                          >
                          </v-text-field>
                        </div>
                        <v-list max-height="180" class="overflow-scroll">
                          <div
                            v-if="!searchDesignation"
                            class="d-flex pa-1 pl-4 pr-2 pointer"
                            :class="
                              !getSearchedDesignation ? 'bg-selected' : ''
                            "
                            @click="
                              $store.commit('setSearchedDesignation', {
                                designation: null,
                              })
                            "
                          >
                            <profileImage
                              v-show="':username'"
                              inline
                              username="All"
                              :size="18"
                              :userProfile="true"
                              :circular="true"
                            >
                            </profileImage>
                            <div class="caption mx-2">All Designations</div>
                            <v-spacer></v-spacer>
                            <v-icon
                              small
                              color="#1cc283"
                              class="justify-end"
                              v-show="!getSearchedDesignation"
                            >
                              mdi-check-box-outline</v-icon
                            >
                          </div>
                          <div
                            v-if="!searchDesignation"
                            class="d-flex pa-1 pl-4 pr-2 pointer"
                            :class="
                              getSearchedDesignation == 'no_designation'
                                ? 'bg-selected'
                                : ''
                            "
                            @click="
                              $store.commit('setSearchedDesignation', {
                                designation: 'no_designation',
                              })
                            "
                          >
                            <profileImage
                              v-show="':username'"
                              inline
                              username="No Designations"
                              :size="18"
                              :userProfile="true"
                              :circular="true"
                            >
                            </profileImage>
                            <div class="caption font-italic grey--text mx-2">
                              No Designations
                            </div>
                            <v-spacer></v-spacer>
                            <v-icon
                              small
                              color="#1cc283"
                              class="justify-end"
                              v-show="
                                getSearchedDesignation == 'no_designation'
                              "
                            >
                              mdi-check-box-outline</v-icon
                            >
                          </div>
                          <div
                            v-for="designation in filteredDesignations"
                            :key="designation.id"
                            class="caption pa-1 pl-4 pr-2 pointer d-flex"
                            :class="
                              getSearchedDesignation &&
                              getSearchedDesignation == designation.name
                                ? 'bg-selected'
                                : ''
                            "
                            @click="
                              getSearchedDesignation &&
                              getSearchedDesignation == designation.name
                                ? $store.commit('setSearchedDesignation', {
                                    designation: null,
                                  })
                                : $store.commit('setSearchedDesignation', {
                                    designation: designation.name,
                                  })
                            "
                          >
                            <profileImage
                              v-show="':username'"
                              inline
                              :username="designation.name"
                              :size="18"
                              :userProfile="true"
                              :circular="true"
                            >
                            </profileImage>
                            <div
                              class="d-inline-block text-truncate mx-2 text-capitalize"
                              style="max-width: 100px"
                            >
                              {{ designation.name }}
                            </div>
                            <v-spacer></v-spacer>
                            <v-icon
                              small
                              color="#1cc283"
                              class="justify-end"
                              v-show="
                                getSearchedDesignation &&
                                  getSearchedDesignation == designation.name
                              "
                            >
                              mdi-check-box-outline</v-icon
                            >
                          </div>
                          <div
                            v-if="
                              searchDesignation && !filteredDesignations.length
                            "
                          >
                            <p class="no-results-found my-1">
                              No results found
                            </p>
                          </div>
                        </v-list>
                      </div>
                    </v-menu>
                  </div>
                </div>
              </td>
            </tr>
          </template>
          <!-- Icon for expanding -->
          <template
            v-slot:[`item.data-table-expand`]="{ expand, isExpanded, item }"
          >
            <div
              v-if="getReportsView == 'leader' || getReportsView == 'project'"
              class="d-flex align-center px-4"
              style="width: 50px"
            >
              <v-btn
                v-if="item"
                class="expanding-chevron-bg px-0"
                icon
                x-small
                @click.stop="expand(!isExpanded)"
              >
                <v-icon color="#1CC283">{{
                  !isExpanded ? "mdi-chevron-right" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
            </div>
          </template>
          <!-- Intervals -->
          <template v-slot:expanded-item="{ item }">
            <td
              v-show="item"
              :class="{
                'ma-0 pa-0': true,
              }"
              class="pa-0 border-0 white"
              colspan="12"
            >
              <!-- Leads Child Table -->
              <TeamLeadMembersEntries
                v-if="getReportsView == 'leader'"
                :headers="leadHeaders"
                :teamLead="item"
                :dateRange="dateRange"
                :getReportsDate="getReportsDate"
                :tableHeight="filteredMemberEntries"
              />
              <!-- Project Child Table -->
              <ProjectMembersEntries
                v-if="getReportsView == 'project'"
                :projectId="item"
                :dateRange="dateRange"
                :getReportsDate="getReportsDate"
                :tableHeight="filteredProjectEntries"
              />
            </td>
          </template>
          <!-- Name Column -->
          <template v-slot:[`item.name`]="{ item }">
            <div class="py-2" :class="getReportsView == 'user' ? 'w-4' : 'w-1'">
              <span
                class="py-0 ml-6 my-0 caption"
                v-if="
                  (getReportsView == 'project' || getReportsView == 'leader') &&
                    completeTaskCount &&
                    getCompleteHigh == item.completed
                "
              >
                <v-chip
                  class="mx-2 my-0 py-0"
                  x-small
                  color="#FFD54F"
                  label
                  text-color="white"
                >
                  <v-icon small left> mdi-star </v-icon>
                  <b>Top Rated</b>
                </v-chip>
              </span>
              <div @click="redirect(item, 'all')" class="py-0 pointer">
                <span class="d-flex justify-content-center">
                  <v-tooltip
                    :disabled="$vuetify.breakpoint.xs"
                    content-class="ma-0 pa-0 tooltip-opacity"
                    open-delay="300"
                    right
                  >
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <profileImage
                          v-show="item.image ? ':src' : ':username'"
                          :src="item.image"
                          inline
                          :username="item.name ? item.name : item.email"
                          :size="28"
                          :userProfile="true"
                          :circular="true"
                        >
                        </profileImage>
                      </div>
                    </template>

                    <!-- Display User info on hover -->
                    <div v-if="getReportsView != 'project'">
                      <UserInfo
                        :image="item.image"
                        :name="item.name"
                        :email="item.email"
                        :designation="item.designation"
                      />
                    </div>
                  </v-tooltip>
                  <v-tooltip
                    :disabled="$vuetify.breakpoint.xs"
                    content-class="arrow-up"
                    color="#DCD8F3"
                    bottom
                  >
                    <template v-slot:activator="{ on }">
                      <div
                        style="max-width: 100px"
                        class="d-inline-block text-truncate ml-3 mt-1"
                        :class="item.name ? 'text-capitalize' : ''"
                        v-on="on"
                      >
                        {{ item.name ? item.name : item.email }}
                      </div>
                    </template>
                    <div
                      class="font-weight-bold dark-purple-text"
                      :class="item.name ? 'text-capitalize' : ''"
                    >
                      {{ item.name ? item.name : item.email }}
                    </div>
                  </v-tooltip>
                </span>
              </div>
            </div>
          </template>
          <!-- Role Column -->
          <template v-slot:[`item.role`]="{ item }">
            <div
              v-show="getReportsView == 'user'"
              @click="redirect(item, 'all')"
              class="pointer"
              :class="getReportsView == 'user' ? 'w-4' : 'w-1'"
            >
              <span class="text-capitalize pointer">
                {{ item.role }}
              </span>
            </div>
          </template>
          <!-- Department Column -->
          <template v-slot:[`item.department`]="{ item }">
            <div
              :class="
                getReportsView == 'user'
                  ? 'w-3'
                  : getReportsView == 'leader'
                  ? 'w-5'
                  : 'w-1'
              "
            >
              <v-tooltip
                :disabled="$vuetify.breakpoint.xs"
                content-class="arrow-up"
                color="#DCD8F3"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <span
                    v-if="getReportsView != 'project'"
                    v-on="on"
                    :class="
                      item.department ? '' : 'caption grey--text font-italic'
                    "
                    class="text-capitalize pointer d-inline-block text-truncate"
                    style="max-width: 80px"
                  >
                    {{ item.department ? item.department : "No department" }}
                  </span>
                </template>
                <span class="text-capitalize font-weight-bold dark-purple-text">
                  {{
                    item.department ? item.department : "No department"
                  }}</span
                >
              </v-tooltip>
            </div>
          </template>
          <!-- Designation Column -->
          <template v-slot:[`item.designation`]="{ item }">
            <div
              :class="
                getReportsView == 'user'
                  ? 'w-3'
                  : getReportsView == 'leader'
                  ? 'w-5'
                  : 'w-1'
              "
            >
              <v-tooltip
                :disabled="$vuetify.breakpoint.xs"
                content-class="arrow-up"
                color="#DCD8F3"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <span
                    v-if="getReportsView != 'project'"
                    v-on="on"
                    :class="
                      item.designation ? '' : 'caption grey--text font-italic'
                    "
                    class="text-capitalize pointer d-inline-block text-truncate"
                    style="max-width: 80px"
                  >
                    {{ item.designation ? item.designation : "No designation" }}
                  </span>
                </template>
                <span class="text-capitalize font-weight-bold dark-purple-text">
                  {{
                    item.designation ? item.designation : "No designation"
                  }}</span
                >
              </v-tooltip>
            </div>
          </template>
          <!-- To Others Column -->
          <template v-slot:[`item.to_others`]="{ item }">
            <div
              :class="
                getReportsView == 'user'
                  ? 'w-3'
                  : getReportsView == 'leader'
                  ? 'w-5'
                  : 'w-1'
              "
            >
              <v-chip
                @click="redirectOthers(item, 'all', 'to_others')"
                class="count-status-chip d-flex justify-center pointer"
                label
                small
                dark
                color="blue-chip-color"
              >
                <span>
                  {{ item.assigned_to_others ? item.assigned_to_others : "0" }}
                </span>
              </v-chip>
            </div>
          </template>
          <!-- By Others Column -->
          <template v-slot:[`item.by_others`]="{ item }">
            <div
              :class="
                getReportsView == 'user'
                  ? 'w-3'
                  : getReportsView == 'leader'
                  ? 'w-5'
                  : 'w-1'
              "
            >
              <v-chip
                @click="redirectOthers(item, 'all', 'by_others')"
                class="count-status-chip d-flex justify-center pointer"
                label
                small
                dark
                color="golden-chip-color"
              >
                <span>
                  {{ item.assigned_by_others ? item.assigned_by_others : "0" }}
                </span>
              </v-chip>
            </div>
          </template>
          <!-- Pending Column -->
          <template v-slot:[`item.pending`]="{ item }">
            <div
              :class="
                getReportsView == 'user'
                  ? 'w-3'
                  : getReportsView == 'leader'
                  ? 'w-5'
                  : 'w-1'
              "
            >
              <v-chip
                @click="redirect(item, 'pending')"
                class="count-status-chip d-flex justify-center pointer"
                label
                small
                dark
                color="yellow-chip-color"
              >
                <span>
                  {{ item.pending }}
                </span>
              </v-chip>
            </div>
          </template>
          <!-- Completed Column -->
          <template v-slot:[`item.completed`]="{ item }">
            <div
              :class="
                getReportsView == 'user'
                  ? 'w-3'
                  : getReportsView == 'leader'
                  ? 'w-5'
                  : 'w-1'
              "
            >
              <v-chip
                @click="redirect(item, 'completed')"
                class="count-status-chip d-flex justify-center pointer"
                label
                small
                dark
                color="green-chip-color"
              >
                <span>
                  {{ item.completed }}
                </span>
              </v-chip>
            </div>
          </template>
          <!-- Overdue Column -->
          <template v-slot:[`item.overdue`]="{ item }">
            <div
              :class="
                getReportsView == 'user'
                  ? 'w-3'
                  : getReportsView == 'leader'
                  ? 'w-5'
                  : 'w-1'
              "
            >
              <v-chip
                @click="redirect(item, 'overdue')"
                class="count-status-chip d-flex justify-center pointer"
                label
                small
                dark
                color="red-chip-color"
              >
                <span>
                  {{ item.overdue }}
                </span>
              </v-chip>
            </div>
          </template>
          <!-- Expired Column -->
          <template v-slot:[`item.expired`]="{ item }">
            <div
              :class="
                getReportsView == 'user'
                  ? 'w-3'
                  : getReportsView == 'leader'
                  ? 'w-5'
                  : 'w-1'
              "
            >
              <v-chip
                @click="redirectOthers(item, 'overdue_completed', 'expired')"
                class="count-status-chip d-flex justify-center pointer"
                label
                small
                dark
                color="expired-chip-color"
              >
                <span>
                  {{ item.completed_overdue }}
                </span>
              </v-chip>
            </div>
          </template>
          <!--Time Spent Column -->
          <template v-slot:[`item.time_spent`]="{ item }">
            <div
              :class="
                getReportsView == 'user'
                  ? 'w-3 '
                  : getReportsView == 'leader'
                  ? 'w-5 '
                  : 'w-1 '
              "
            >
              <span dark>
                {{ item.total_time }}
              </span>
            </div>
          </template>

          <!-- Total time column -->
          <template v-slot:[`item.total_time`]="{ item }">
            <div
              :class="
                getReportsView == 'user'
                  ? 'w-3'
                  : getReportsView == 'leader'
                  ? 'w-5'
                  : 'w-1'
              "
            >
              <span dark>
                {{ item.total_time }}
              </span>
            </div>
          </template>

          <!-- Action Column -->
          <template v-slot:[`item.action`]="{ item }">
            <!-- info icon -->
            <v-layout class="d-flex justify-end px-3">
              <div>
                <v-tooltip
                  :disabled="
                    $vuetify.breakpoint.xs || getReportsView == 'project'
                  "
                  color="#DCD8F3"
                  content-class="arrow-up"
                  bottom
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-hover>
                      <v-icon
                        :disabled="getReportsView == 'project'"
                        v-on="on"
                        v-bind="attrs"
                        class="dark-purple-text mr-6"
                        small
                        @click="taskEntries(item)"
                      >
                        mdi-information-outline</v-icon
                      >
                    </v-hover>
                  </template>
                  <span class="font-weight-bold dark-purple-text">
                    Task Details</span
                  >
                </v-tooltip>
              </div>
            </v-layout>
          </template>
        </v-data-table>
      </div>
      <!-- Pagination -->
      <div
        v-if="$vuetify.breakpoint.xs"
        class="d-flex justify-center flex-column"
      >
        <v-pagination
          :class="$vuetify.breakpoint.xs ? 'mt-2' : ''"
          id="pagination"
          color="#302277"
          v-model="currentPage"
          :length="paginationLength"
          circle
        ></v-pagination>
        <div class="d-flex justify-center">
          <span class="my-2 text-center caption pagination-text-color">
            Showing
            {{ pageStart ? pageStart : 1 }}-{{ pageStop ? pageStop : 1 }}
            of
            {{
              getReportsView == "leader"
                ? filteredMemberEntries
                  ? filteredMemberEntries.length
                  : 0
                : getReportsView == "user"
                ? filteredMemberEntries
                  ? filteredMemberEntries.length
                  : 0
                : getReportsView == "project"
                ? filteredProjectEntries
                  ? filteredProjectEntries.length
                  : 0
                : ""
            }}
            entries
          </span>
        </div>
      </div>
      <div
        class="d-flex w-100 align-center overflow-scroll"
        :class="[$vuetify.breakpoint.xs ? '' : 'px-4']"
      >
        <div class="d-flex w-100 my-1 align-center">
          <span class="ml-2 pagination-text-color d-flex align-center">
            View:
          </span>
          <!-- hidden on sm screens -->
          <div
            :style="
              isExtension
                ? 'width: 65px'
                : $vuetify.breakpoint.xs
                ? 'width: 85px;'
                : 'width: 82px;'
            "
            class="pa-0 mx-1"
            style="width: 95%"
            :cols="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? 2 : 1"
          >
            <v-select
              id="reports-pg-selector"
              style="display: inline-table"
              hide-details
              dense
              solo
              flat
              class="subtitle-2 px-n2"
              :items="[5, 10, 25, 50, 100]"
              v-model="perPage"
            />
          </div>
          <!-- hidden on sm-screens -->
          <span
            class="d-none d-sm-flex pagination-text-color"
            :class="
              $vuetify.breakpoint.xs ? 'subtitle-2 my-2 ' : 'd-flex align-end'
            "
            >rows per page</span
          >
        </div>
        <v-spacer></v-spacer>
        <div
          class="d-flex justify-end align-center w-100 body-2 dusty-purple-text"
        >
          <v-menu min-width="120" content-class="dropdown" offset-y>
            <template #activator="{ on: onMenu }">
              <v-tooltip
                :disabled="$vuetify.breakpoint.xs"
                color="#DCD8F3"
                content-class="arrow-up"
                bottom
              >
                <template #activator="{ on: onTooltip }">
                  <div class="d-flex align-center">
                    <v-btn
                      small
                      width="20"
                      outlined
                      class="text-capitalize dark-purple-text d-flex align-center mx-1"
                      text
                      v-on="{ ...onMenu, ...onTooltip }"
                    >
                      <v-icon class="mx-1">mdi-printer</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span class="font-weight-bold dark-purple-text">Download</span>
              </v-tooltip>
            </template>
            <v-list class="pt-1 pb-0">
              <v-list-item
                class="listing-hover pointer"
                @click="download('csv')"
              >
                <img
                  src="@/assets/images/Csv_icon.png"
                  height="16px"
                  class="mr-1"
                />
                <v-list-item-title class="listing-hover">CSV</v-list-item-title>
              </v-list-item>
              <v-list-item class="listing-hover pointer">
                <img
                  src="@/assets/images/Excel_icon.png"
                  height="20px"
                  class="mr-1"
                />
                <a
                  class="dropdown-item text-decoration-none"
                  href="#"
                  style="color: black"
                >
                  <download-excel
                    :data="excelDownload.data"
                    :labels="excelDownload.labels"
                    :name="excelDownload.name"
                    worksheet="abc"
                    >Excel</download-excel
                  >
                </a>
              </v-list-item>
            </v-list>
          </v-menu>
          <div
            v-if="!$vuetify.breakpoint.xs"
            :class="
              $vuetify.breakpoint.xs
                ? 'd-flex text-center flex-column-reverse px-0 '
                : 'd-flex justify-start mt-2 px-0'
            "
            :style="!$vuetify.breakpoint.xs ? 'min-width:200px' : ''"
          >
            <span
              class="my-1 pagination-text-color"
              :class="$vuetify.breakpoint.xs ? 'my-2 text-center caption' : ''"
              :style="!$vuetify.breakpoint.xs ? 'min-width:200px' : ''"
            >
              {{
                !($vuetify.breakpoint.xs || $vuetify.breakpoint.sm)
                  ? "Showing"
                  : ""
              }}
              {{ pageStart ? pageStart : 1 }}-{{ pageStop ? pageStop : 1 }}
              of
              {{
                getReportsView == "leader"
                  ? filteredMemberEntries
                    ? filteredMemberEntries.length
                    : 0
                  : getReportsView == "user"
                  ? filteredMemberEntries
                    ? filteredMemberEntries.length
                    : 0
                  : getReportsView == "project"
                  ? filteredProjectEntries
                    ? filteredProjectEntries.length
                    : 0
                  : ""
              }}
              {{ $vuetify.breakpoint.xs ? "" : "entries" }}
            </span>
            <v-pagination
              :class="$vuetify.breakpoint.xs ? 'mt-2' : ''"
              id="pagination"
              color="#302277"
              v-model="currentPage"
              :length="paginationLength"
              circle
              :total-visible="5"
            ></v-pagination>
          </div>

          <span
            style="min-width: 100px"
            class="mr-0"
            v-show="
              $vuetify.breakpoint.md ||
                $vuetify.breakpoint.lg ||
                $vuetify.breakpoint.xl
            "
          >
            Go to:
            <input
              v-model="pageInput"
              @keydown.enter="goToPage"
              type="number"
              class="dark-purple-text theme-border pagination-input pl-1 mr-1 rounded-sm"
            />
          </span>
        </div>
      </div>
    </div>
    <template v-if="openMemberTasksModal">
      <TasksModal
        :openMemberTasksModal.sync="openMemberTasksModal"
        :fetchTaskEntriesLoader.sync="fetchTaskEntriesLoader"
        :userId="memberDetails"
        :entriesDetail="entriesDetail"
      />
    </template>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
import exportTable from "@/table-export.js";
import UserInfo from "@/components/TeamMembers/UserInfo";
import TeamLeadMembersEntries from "@/components/Reports/TeamLeadMembersEntries";
import ProjectMembersEntries from "@/components/Reports/ProjectMembersEntries";
import profileImage from "@/components/Includes/ProfileImage";
import JsonExcel from "vue-json-excel";
import { eventBus } from "@/main";
export default {
  name: "Reports",
  components: {
    TeamLeadMembersEntries,
    ProjectMembersEntries,
    profileImage,
    UserInfo,
    downloadExcel: JsonExcel,
    Error403: () => import("@/components/Includes/403.vue"),
    TasksModal: () => import("@/components/Reports/TasksModal"),
  },
  data() {
    return {
      // Search filters
      memberDetails: null,
      openMemberTasksModal: false,
      abc: false,
      no_department: true,
      searchName: null,
      searchDepartment: null,
      searchDesignation: null,
      completeTaskCount: false,
      getCompleteHigh: "",
      reportsDropdown: false,
      details: null,
      currentPage: 1,
      perPage: 100,
      pageCount: 1,
      pageStart: 1,
      pageInput: 1,
      pageStop: 100,
      fetchLinearLoader: false,
      fetchTaskEntriesLoader: false,
      searchedName: null,
      searchedRole: null,
      searchedDepartment: null,
      search: null,
      completedSort: null,
      pendingSort: null,
      overdueSort: null,
      expiredSort: null,
      roleSort: null,
      toOthersSort: null,
      byOthersSort: null,
      timeSpentSort: null,
      searchTeamLead: null,
      searchMember: null,
      selectedDates: [],
      selectedDateItem: "Yesterday",
      customRangeMenu: false,
      customRange: [],
      entriesDetail: [],
      dateRanges: [
        { text: "Today" },
        { text: "Yesterday" },
        { text: "Last 7 days" },
        { text: "Last 30 days" },
        { text: "This month" },
        { text: "All time" },
      ],
      roles: [
        { text: "All", value: "" },
        { text: "Admin", value: "admin" },
        { text: "Employee", value: "employee" },
        { text: "Team Manager", value: "team-manager" },
      ],
      headers: [
        {
          text: "",
          value: "data-table-expand",
          sortable: false,
          class: "table-header-bg",
          cellClass: "px-0",
        },
        {
          text: "Name",
          value: "name",
          sortable: false,
          class: "table-header-bg",
          cellClass: "px-0",
          width: "80px",
        },
        {
          text: "Role",
          value: "role",
          class: "table-header-bg px-0",
          sortable: false,
          width: "80px",
          cellClass: "px-0",
        },
        {
          text: "Department",
          value: "department",
          class: "table-header-bg px-0",
          sortable: false,
          width: "70px",
          cellClass: "px-0",
        },
        {
          text: "Designation",
          value: "designation",
          class: "table-header-bg px-0",
          sortable: false,
          width: "70px",
          cellClass: "px-0",
        },
        {
          text: "To Others",
          value: "to_others",
          class: "table-header-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "70px",
        },
        {
          text: "By Others",
          value: "by_others",
          class: "table-header-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "70px",
        },
        {
          text: "Completed",
          value: "completed",
          class: "table-header-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "50px",
        },
        {
          text: "Pending",
          value: "pending",
          class: "table-header-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "50px",
        },
        {
          text: "Overdue",
          value: "overdue",
          class: "table-header-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "50px",
        },
        {
          text: "Expired",
          value: "expired",
          class: "table-header-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "50px",
        },
        {
          text: "Time Spent",
          value: "time_spent",
          class: "table-header-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "50px",
        },

        {
          text: "Action",
          value: "action",
          class: "table-header-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "50px",
        },
      ],
      projectHeaders: [
        {
          text: "",
          value: "data-table-expand",
          sortable: false,
          class: "table-header-bg",
          cellClass: "pl-2 pr-0",
        },
        {
          text: "Name",
          value: "name",
          sortable: false,
          class: "table-header-bg px-0",
          cellClass: "px-0",
          width: "80px",
        },
        {
          text: "Designation",
          value: "designation",
          sortable: false,
          class: "table-header-bg px-0",
          cellClass: "px-0",
          width: "100px",
        },
        {
          text: "Department",
          value: "department",
          sortable: false,
          class: "table-header-bg px-0",
          cellClass: "px-0",
          width: "100px",
        },
        {
          text: "Completed",
          value: "completed",
          class: "table-header-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "100px",
        },
        {
          text: "Pending",
          value: "pending",
          class: "table-header-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "100px",
        },
        {
          text: "Overdue",
          value: "overdue",
          class: "table-header-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "100px",
        },
        // {
        //   text: "Expired",
        //   value: "expired",
        //   class: "table-header-bg px-0",
        //   sortable: false,
        //   cellClass: "px-0",
        //   width: "50px",
        // },
        {
          text: "Total time",
          value: "total_time",
          class: "table-header-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "100px",
        },
        {
          text: "Action",
          value: "action",
          class: "table-header-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "100px",
        },
      ],
      leadHeaders: [
        {
          text: "",
          value: "data-table-expand",
          sortable: false,
          class: "table-header-bg",
          cellClass: "px-0",
        },
        {
          text: "Name",
          value: "name",
          sortable: false,
          class: "table-header-bg",
          cellClass: "px-0",
          width: "80px",
        },
        {
          text: "Department",
          value: "department",
          class: "table-header-bg px-0",
          sortable: false,
          width: "70px",
          cellClass: "px-0",
        },
        {
          text: "Designation",
          value: "designation",
          class: "table-header-bg px-0",
          sortable: false,
          width: "70px",
          cellClass: "px-0",
        },
        {
          text: "To Others",
          value: "to_others",
          class: "table-header-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "60px",
        },
        {
          text: "By Others",
          value: "by_others",
          class: "table-header-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "60px",
        },
        {
          text: "Completed",
          value: "completed",
          class: "table-header-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "60px",
        },
        {
          text: "Pending",
          value: "pending",
          class: "table-header-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "60px",
        },
        {
          text: "Overdue",
          value: "overdue",
          class: "table-header-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "60px",
        },
        {
          text: "Expired",
          value: "expired",
          class: "table-header-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "50px",
        },
        {
          text: "Time Spent",
          value: "time_spent",
          class: "table-header-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "60px",
        },
        {
          text: "Action",
          value: "action",
          class: "table-header-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "60px",
        },
      ],
      excel_fields: {
        details: {
          labels: {
            Project_Name: "Project_Name",
            Email: "Email",
            Role: "Role",
            Completed_Tasks: "Completed_Tasks",
            Pending_Tasks: "Pending_Tasks",
            Overdue_Tasks: "Overdue_Tasks",
            Total_Time: "Total_Time",
            Member_Name: "Member_Name",
            Member_Total_Time: "Member_Total_Time",
            
          },
          fields: [
            "Project_Name",
            "Email",
            "Role",
            "Completed_Tasks",
            "Pending_Tasks",
            "Overdue_Tasks",
            "Total_Time",
            "Member_Name",
            "Member_Total_Time",
            
          ],
          dataFile: "Reports.xls",
        },
      },
    };
  },
  computed: {
    ...mapGetters([
      "getLoggedInUser",
      "getAllMembers",
      "getSelectedCompany",
      "getReports",
      "getSidebarMini",
      "getProjects",
      "getRestrictStatus",
      "getReportsStatus",
      "getReportsDate",
      "getReportsView",
      "getReportsSearchQuery",
      "getSearchedRole",
      "getProjectSearchedQuery",
      "getDepartments",
      "getDesignations",
      "getSearchedDepartment",
      "getSearchedDesignation",
      "getSearchedName",
      "getReportColumn",
      "getDisbaleFlag",
      "getCustomDateRange"
    ]),
    // Number of pages
    paginationLength() {
      return Math.ceil(
        this.getReportsView == "leader"
          ? this.filteredMemberEntries.length / this.perPage
          : this.getReportsView == "user"
          ? this.filteredMemberEntries.length / this.perPage
          : this.getReportsView == "project"
          ? this.filteredProjectEntries.length / this.perPage
          : ""
      );
    },
    filteredMembers() {
      return this.getReports
        ? this.searchName
          ? this.getReports.filter((item) => {
              return item.name
                ? item.name
                    .toLowerCase()
                    .includes(this.searchName.toLowerCase())
                : item.email
                    .toLowerCase()
                    .includes(this.searchName.toLowerCase());
            })
          : this.getReports
        : [];
    },
    filteredDepartments() {
      return this.searchDepartment && this.getDepartments
        ? this.getDepartments.filter((item) => {
            return item.name
              ? item.name
                  .toLowerCase()
                  .includes(this.searchDepartment.toLowerCase())
              : false;
          })
        : this.getDepartments;
    },
    filteredDesignations() {
      return this.searchDesignation && this.getDesignations
        ? this.getDesignations.filter((item) => {
            return item.name
              ? item.name
                  .toLowerCase()
                  .includes(this.searchDesignation.toLowerCase())
              : false;
          })
        : this.getDesignations;
    },
    // Filtered Members Entries (Search on the basis of name, email, role)
    filteredMemberEntries() {
      let reports = [];
      if (this.getReports) {
        reports = this.getReports;
        if (this.getSearchedName) {
          reports = reports.filter((item) => {
            return item.name && this.getSearchedName.name
              ? item.name
                  .toLowerCase()
                  .includes(this.getSearchedName.name.toLowerCase())
              : item.email && this.getSearchedName.email
              ? item.email
                  .toLowerCase()
                  .includes(this.getSearchedName.email.toLowerCase())
                ? true
                : false
              : () => {};
          });
        }
        if (this.getSearchedRole) {
          reports = reports.filter((item) => {
            return item.role &&
              item.role
                .toLowerCase()
                .includes(this.getSearchedRole.toLowerCase())
              ? true
              : false;
          });
        }
        if (
          this.getSearchedDepartment &&
          this.getSearchedDepartment != "no_department"
        ) {
          reports = reports.filter((item) => {
            return item.department &&
              item.department
                .toLowerCase()
                .includes(this.getSearchedDepartment.toLowerCase())
              ? true
              : false;
          });
        }
        if (this.getSearchedDepartment == "no_department") {
          reports = reports.filter((item) => {
            return !item.department;
          });
        }
        if (
          this.getSearchedDesignation &&
          this.getSearchedDesignation != "no_designation"
        ) {
          reports = reports.filter((item) => {
            return item.designation &&
              item.designation
                .toLowerCase()
                .includes(this.getSearchedDesignation.toLowerCase())
              ? true
              : false;
          });
        }
        if (this.getSearchedDesignation == "no_designation") {
          reports = reports.filter((item) => {
            return !item.designation;
          });
        }
        return reports;
      }
      return [];
    },
    // Filtered project entries
    filteredProjectEntries() {
      let reports = [];
      if (this.getReports) {
        reports = this.getReports;
        if (this.getProjectSearchedQuery) {
          reports = reports.filter((item) => {
            return item.name &&
              item.name
                .toLowerCase()
                .includes(this.getProjectSearchedQuery.name.toLowerCase())
              ? true
              : false;
          });
        }
        if (this.getReportsSearchQuery) {
          reports = reports.filter((item) => {
            return item.users.length &&
              item.users.find((user) => {
                return user.id == this.getReportsSearchQuery.id;
              })
              ? true
              : false;
          });
        }
        return reports;
      }
      return [];
    },
    // Date range filter
    dateRange() {
      if (this.getReportsDate == "Today")
        return [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")];
      if (this.getReportsDate == "Yesterday")
        return [
          moment()
            .subtract(1, "day")
            .format("YYYY-MM-DD"),
          moment()
            .subtract(1, "day")
            .format("YYYY-MM-DD"),
        ];
      if (this.getReportsDate == "Last 7 days")
        return [
          moment()
            .subtract(6, "day")
            .format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ];
      if (this.getReportsDate == "Last 30 days")
        return [
          moment()
            .subtract(29, "day")
            .format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ];
      if (this.getReportsDate == "This month")
        return [
          moment()
            .clone()
            .startOf("month")
            .format("YYYY-MM-DD"),
          moment()
            .clone()
            .endOf("month")
            .format("YYYY-MM-DD"),
        ];
        if (this.getReportsDate == "Custom range") {
          return [this.getCustomDateRange[0], 
                  this.getCustomDateRange[1]];
           }
      if (this.getReportsDate == "Last month") {
        return [
          moment()
            .subtract(1, "months")
            .startOf("month")
            .format("YYYY-MM-DD"),
          moment()
            .subtract(1, "months")
            .endOf("month")
            .format("YYYY-MM-DD"),
        ];
      }
      if (this.getReportsDate == "All time")
        return ["2000-01-01", moment().format("YYYY-MM-DD")];
      else if (this.customRange)
        return [
          moment(this.customRange[0]).format("YYYY-MM-DD"),
          moment(this.customRange[1]).format("YYYY-MM-DD"),
        ];
      return [];
    },
    // To download excel sheet and CSV file
    excelDownload() {
      return {
        data:
          this.getReportsView == "user" || this.getReportsView == "leader"
            ? this.membersJson
            : this.projectsJson,
        name: this.excel_fields.details.dataFile,
        labels: this.excel_fields.details.labels,
        fields: this.excel_fields.details.fields,
      };
    },
    // CSV download for members and team-leads
    membersJson: function() {
      let rawData =
        this.getReportsView == "leader"
          ? this.filteredMemberEntries
          : this.getReportsView == "user"
          ? this.filteredMemberEntries
          : "";
      let json = [];
      if (rawData) {
        rawData.forEach((member) => {
          let user = {};
          user.Name = member.name
            ? member.name[0].toUpperCase() + member.name.slice(1)
            : member.email;
          user.Email = member.email;
          (user.Role = member.role
            ? member.role[0].toUpperCase() + member.role.slice(1)
            : ""),
            (user.Completed_Tasks = member.completed);
          user.Pending_Tasks = member.pending;
          user.Overdue_Tasks = member.overdue;
          user.Total_Time = member.total_time;
          json.push(user);
        });
      }
      return json;
    },
    // CSV download for projects

     projectsJson: function() {
      let rawData =
        this.getReportsView == "project" ? this.filteredProjectEntries : "";
      let json = [];
      if (rawData) {
        rawData.forEach((project) => {
          if (project.users.length) {
            project.users.forEach((member)=>{
              let projects = {};
          projects.Project_Name = project.name
            ? project.name[0].toUpperCase() + project.name.slice(1)
            : "";
          projects.Completed_Tasks = project.completed;
          projects.Pending_Tasks = project.pending;
          projects.Overdue_Tasks = project.overdue;
          projects.Total_Time = project.total_time;
          projects.Member_Name = member.name;
          projects.Member_Total_Time = member.total_time;
          json.push(projects);
            })
          }
          else {
            let projects = {};
          projects.Name = project.name
            ? project.name[0].toUpperCase() + project.name.slice(1)
            : "";
          projects.Completed_Tasks = project.completed;
          projects.Pending_Tasks = project.pending;
          projects.Overdue_Tasks = project.overdue;
          projects.Total_Time = project.total_time;
          json.push(projects);
          }
        });
      }
      return json;
    },
    
 },
  methods: {
    fetchCall() {
      this.clearFilters();
      if (this.getReportsView == "user") {
        this.fetchLinearLoader = true;
        this.$store
          .dispatch("fetchMembersReports", {
        start_date: this.getCustomDateRange[0],
        end_date: this.getCustomDateRange[1],
        status: this.getReportsStatus,
      })
          .finally(() => {
            this.fetchLinearLoader = false;
          });
      } else if (this.getReportsView == "project") {
        this.fetchLinearLoader = true;
        this.$store
          .dispatch("fetchProjectReports", {
        start_date: this.getCustomDateRange[0],
        end_date: this.getCustomDateRange[1],
        status: this.getReportsStatus,
      })
          .finally(() => {
            this.fetchLinearLoader = false;
            this.checkReportsProject();
          });
      } else if (this.getReportsView == "leader") {
        this.fetchLinearLoader = true;
        this.$store
          .dispatch("fetchLeadsReports", {
        start_date: this.getCustomDateRange[0],
        end_date: this.getCustomDateRange[1],
        status: this.getReportsStatus,
      })
          .finally(() => {
            this.$store.commit(
              "setCompletedTaskSorting",
              (this.completedSort = "desc")
            );
            this.fetchLinearLoader = false;
            this.checkReportsProject();
          });
      }
    },
    checkReportsProject() {
      let obj = this.getReports.filter((comp) => {
        return comp.completed;
      });
      let max_count = Math.max.apply(
        Math,
        obj.map(function(o) {
          return o.completed;
        })
      );
      if (max_count) {
        this.completeTaskCount = true;
        this.getCompleteHigh = max_count;
      }
    },
    // Clear filters
    clearFilters() {
      this.roleSort = null;
      this.completedSort = null;
      this.pendingSort = null;
      this.overdueSort = null;
      this.timeSpentSort = null;
      this.searchedName = null;
      this.searchedRole = null;
      this.currentPage = 1;
    },
    updatePagination(value) {
      if (value) {
        this.pageInput = value.page;
        this.currentPage = value.page;
        this.pageStart = value.pageStart;
        this.pageStop = value.pageStop;
        this.pageCount = value.pageCount;
      }
    },
    goToPage() {
      if (
        parseInt(this.pageInput) > 0 &&
        parseInt(this.pageInput) <= this.pageCount
      )
        this.currentPage = parseInt(this.pageInput);
    },
    // Redirection to Task Page
    redirect(item, status) {
      this.allTheTime = ["2000-01-01", moment().format("YYYY-MM-DD")];
      this.$store.commit("setTaskFilter", {
        status,
        assigned_to:
          this.getReportsView == "user" || this.getReportsView == "leader"
            ? [item]
            : [],
        start_date:
          status == "pending" || status == "overdue"
            ? this.allTheTime[0]
            : this.dateRange[0],
        end_date:
          status == "pending" || status == "overdue"
            ? this.allTheTime[1]
            : this.dateRange[1],
        show_tasks: this.getSelectedCompany.role == "employee" ? "me" : "all",
        redirect: status == "pending" ? true : false,
        title: null,
        page: 1,
        project_id: this.getReportsView == "project" ? [item.id] : [],
        assigned_by: this.getReportsStatus == "self" ? [item] : [],
        report: false,
      });

      this.$store.commit(
        "setTaskDateFilter",
        status == "pending" || status == "overdue"
          ? "All time"
          : this.getReportsDate
      );
      localStorage.setItem("redirection", true);
      window.open("task");
    },
    redirectOthers(item, status, others) {
      this.$store.commit("setTaskFilter", {
        status,
        assigned_to: others == "by_others" || others == "expired" ? [item] : [],
        start_date: this.dateRange[0],
        end_date: this.dateRange[1],
        show_tasks: this.getSelectedCompany.role == "employee" ? "me" : "all",
        redirect: false,
        title: null,
        page: 1,
        project_id: [],
        assigned_by: others == "to_others" ? [item] : [],
        report: others == "expired" ? false : true,
      });
      this.$store.commit("setTaskDateFilter", this.getReportsDate);
      localStorage.setItem("redirection", true);
      window.open("task");
    },
    // Method to downlaod the CSV table for (Members, Team-leads and Projects)
    download(format) {
      this.getReportsView == "user" || this.getReportsView == "leader"
        ? exportTable.ReportsTableExport(
            this.filteredMemberEntries,
            "Reports",
            format
          )
        : this.getReportsView == "project"
        ? exportTable.ReportsProjectTableExport(
            this.filteredMemberEntries,
            "Reports",
            format
          )
        : "";
    },
    // This function returns search filters if applied
    getSearchFilters() {
      return {
        start_date: this.dateRange[0],
        end_date: this.dateRange[1],
        status: this.getReportsStatus,
      };
    },
    taskEntries(item) {
      if (this.getReportsView != "project") {
        this.memberDetails = item;
        this.openMemberTasksModal = true;
        this.fetchTaskEntriesLoader = true;
        this.$store
          .dispatch("fetchReportsTasksByTimeEntries", {
            company_id: this.getSelectedCompany.id,
            user_id: item.id,
            start_date: this.dateRange[0],
            end_date: this.dateRange[1],
            status: this.getReportsStatus,
          })
          .finally(() => {
            this.fetchTaskEntriesLoader = false;
          });

        this.$store
          .dispatch("fetchReportsTasksTimeEntriesDetails", {
            company_id: this.getSelectedCompany.id,
            start_date: this.dateRange[0],
            end_date: this.dateRange[1],
            status: this.getReportsStatus,
            employee: item.id,
          })
          .then((res) => {
            this.entriesDetail = res;
            this.fetchTaskEntriesLoader = false;
          })
          .catch(() => {});
      }
    },
  },
  mounted() {
    this.$store.dispatch("fetchTeamMembers");
    this.fetchLinearLoader = true;
    this.getSelectedCompany.role == "owner" ||
    this.getSelectedCompany.role == "admin"
      ? this.$store.dispatch("fetchLeadsReports").finally(() => {
          this.fetchLinearLoader = false;
        })
      : this.$store.dispatch("fetchMembersReports").finally(() => {
          this.fetchLinearLoader = false;
        });
    this.$store.commit("setSearchedDepartment", { department: null });
    this.$store.commit("setSearchedDesignation", { designation: null });
    this.$store.commit("setSearchedProject", null);
    this.$store.commit("setMemberSearched", null);
    this.$store.commit("setReportsStatus", {
      status: "all",
    });
    this.$store.commit(
      "setReportsView",
      this.getSelectedCompany.role == "owner" ||
        this.getSelectedCompany.role == "admin"
        ? "leader"
        : "user"
    );
    this.$store.commit("setReportsDate", "Yesterday");
    this.teamMembers = this.getAllMembers.filter((item) => {
      return item.id != this.getLoggedInUser.id;
    });
    this.teamMembers.unshift(this.getLoggedInUser);
  },
  watch: {
    getCustomDateRange(value) {
      if(value && value.length && value.length == 2) this.fetchCall()
    },
    getReportsDate(value) {
      if(value != 'Custom range') {
        this.$store.commit('setCustomDateRange', [])
        eventBus.$emit('customDateRange', [])
      } 
      if(value != 'Custom range') {
         this.clearFilters();
      if (this.getReportsView == "user") {
        this.fetchLinearLoader = true;
        this.$store
          .dispatch("fetchMembersReports", this.getSearchFilters())
          .finally(() => {
            this.fetchLinearLoader = false;
          });
      } else if (this.getReportsView == "project") {
        this.fetchLinearLoader = true;
        this.$store
          .dispatch("fetchProjectReports", this.getSearchFilters())
          .finally(() => {
            this.fetchLinearLoader = false;
            this.checkReportsProject();
          });
      } else if (this.getReportsView == "leader") {
        this.fetchLinearLoader = true;
        this.$store
          .dispatch("fetchLeadsReports", this.getSearchFilters())
          .finally(() => {
            this.$store.commit(
              "setCompletedTaskSorting",
              (this.completedSort = "desc")
            );
            this.fetchLinearLoader = false;
            this.checkReportsProject();
          });
      }
      }
    },
    // Watch the flag value changes from (members, team-leads or projects)
    getReportsView(value, oldValue) {
      this.clearFilters();
      if (oldValue != value) this.$store.commit("setReports", []);
      if (value == "user") {
        this.fetchLinearLoader = true;
        this.$store
          .dispatch("fetchMembersReports", this.getSearchFilters())
          .finally(() => {
            this.fetchLinearLoader = false;
          });
      } else if (value == "project") {
        this.fetchLinearLoader = true;
        this.$store
          .dispatch("fetchProjectReports", this.getSearchFilters())
          .finally(() => {
            this.fetchLinearLoader = false;
            this.checkReportsProject();
          });
      } else if (value == "leader") {
        this.fetchLinearLoader = true;
        this.$store
          .dispatch("fetchLeadsReports", this.getSearchFilters())
          .finally(() => {
            this.fetchLinearLoader = false;
            this.checkReportsProject();
          });
      }
    },
    getReportsStatus(value) {
      this.fetchLinearLoader = true;
      if (this.getReportsView == "user") {
        this.$store
          .dispatch("fetchMembersReports", this.getSearchFilters())
          .then(() => {
            this.fetchLinearLoader = false;
            this.reportsDropdown = false;
          });
      } else if (this.getReportsView == "leader") {
        this.$store
          .dispatch("fetchLeadsReports", this.getSearchFilters())
          .finally(() => {
            this.fetchLinearLoader = false;
            this.checkReportsProject();
          });
      } else if (this.getReportsView == "project") {
        this.$store
          .dispatch("fetchProjectReports", this.getSearchFilters())
          .finally(() => {
            this.fetchLinearLoader = false;
            this.checkReportsProject();
          });
      }
    },
  },
};
</script>

<style scoped>
.w-1 {
  width: 190px !important;
}
.w-2 {
  width: 300px !important;
}
.w-3 {
  width: 90px !important;
}
.w-4 {
  width: 135px !important;
}
.w-5 {
  width: 130px !important;
}
.views-btn {
  background-color: #1cc283;
  color: #fff;
  font-size: 13px;
  font-weight: 800;
}
.v-progress-linear {
  background: transparent;
  overflow: hidden;
  position: initial;
  transition: 0.2s cubic-bezier(0.4, 0, 0.6, 1);
  width: 100%;
}
.inputContainer i {
  position: absolute;
}
.date-range-dropdown {
  min-height: 32px;
}
.date-range-dropdown:hover {
  background-color: #e9fcf5;
}

.date-range-text-color {
  color: #757096;
  font-size: 12px;
  font-style: Roboto Medium;
}
.date-range-text-color:hover {
  color: #1cc283 !important;
}
.claender-ok-btn {
  background-color: #edebf9;
}
.expanding-chevron-bg {
  border: 1px solid #1cc283;
  background-color: rgba(28, 194, 131, 0.12);
}
.header-search-input-field {
  border: 1px #dad6f5 solid;
  border-radius: 2px;
  height: 22px;
  font-weight: lighter;
  padding-left: 15;
  margin-left: -17px;
}
.header-search-input-field::placeholder {
  color: grey !important;
  font-size: 13px;
}
.mdi-magnify::before {
  margin-left: -15px;
}
</style>
